module.exports = __webpack_public_path__ + "img/航天科工.74827a30.jpg";